import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 展示身份证正反面识别输入参数配置
 */
export type FabricMarkShowIdCardOptions = {
  /**
   * 正面还是反面.
   * @default false
   */
  isPositive: boolean;
  /**
   * 是否打开相册.
   */
  isNeedAlbum: boolean;
};

/**
 * 从本地相册选择图片或使用相机拍照, 结果返回.
 */
export type FabricMarkShowIdCardCallbackData = {
  /**
   * 调用成功时始终返回 status = "0"
   */
  status: '0';
  /**
   * 预留消息
   */
  message: string;
  /**
   * 正面图片/反面图片, 如果参数传递`isPositive`则返回正面的base64, 否则返回反面base64
   */
  idCardImgBase64?: string;
};

export type FabricMarkShowIdCardApi = (
  options: FabricMarkShowIdCardOptions
) => Promise<FabricMarkShowIdCardCallbackData>;

/**
 * 展示身份证正反面识别
 */
export const showIdCard: FabricMarkShowIdCardApi = (
  options: FabricMarkShowIdCardOptions
): Promise<FabricMarkShowIdCardCallbackData> => {
  return new Promise<FabricMarkShowIdCardCallbackData>((resolve, reject) => {
    core.call<
      'fabric_mark_idcard.showIdCard',
      FabricMarkShowIdCardOptions,
      FabricMarkShowIdCardCallbackData
    >('fabric_mark_idcard.showIdCard', options, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
